"use strict";
gradeSetup.classy.controller({
    name: "GradeSetupController",
    inject: ["$scope", "$http", "$modal", "$rootScope", 
        "DateService", "GradeSetupModelService", "HelpSystemModelService", "SchoolModelService",
        "authServiceFactory", "standardCudArrayFactory"],
    init: function()
    {
        this.$.GradeSetupModelService = this.GradeSetupModelService;
        this.$.SetAllModalService = this.SetAllModalService;
        this.$rootScope.model = this.GradeSetupModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.arrayCud = new this.standardCudArrayFactory(this.GradeSetupModelService,
            this.authServiceFactory.getAuth().schoolID, 
            this.GradeSetupModelService.data, this, ["items"]);
        this.$.items = this.GradeSetupModelService.data;
        this.$.HelpSystemModelService = this.HelpSystemModelService; 
        this.$.editing = false;
        this.$.adding = false;
        const self = this;
        this.$.sortableOptions = {
            stop: function() {
                self.$.editing = true;
                self.$.newOrder = [];
                $(".graderow").each(function(index) {
                    self.$.newOrder[index] = $(this).attr("id");
                });
                for (let key in self.$.newOrder) {
                    for (let key2 in self.$.items) {
                        if (self.$.newOrder[key] == self.$.items[key2].recordID) {
                            self.$.items[key2].questionOrder = parseInt(key) + 1;
                        }
                    }
                }
                self.$.$apply();
            },
            items: "li:not(.not-sortable)"
        };
        this.$.currentYear = this.DateService.getCurrentYear();
    },
    check: function(index) //This is used to prevent single and double quotes from being put in the grade description
    {
        let str = this.$.items[index].divisionDesc
        if (str[str.length-1]=='\'' || str[str.length-1]=='"') {
            str = str.substring(0, str.length - 1);
            this.$.items[index].divisionDesc = str;
        }
    },
    deleteClick: function(grade, index) 
    {
        var parent = this;
        if (this.$.items[index].recordID!==undefined) {
            swal({
                title: "Are you sure?",
                text: "If this grade is deleted, any application that was previously submitted with this grade level will have the grade and tuition removed for that applicant. Are you sure you want to delete this grade?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD68BB",
                confirmButtonText: "Yes",
                closeOnConfirm: true
            },
            function(isConfirm) {
                if (isConfirm) {
                    parent.$.items[index].InUse=0; 
                    parent.$.items[index].del=1; 
                    
                    parent.$.arrayCud.del(index); 
                    parent.$.$apply()
                }            
            });
        }
        else {
            this.$.items[index].InUse=0; 
            this.$.items[index].del=1; 
            
            this.$.arrayCud.del(index); 
        }
    },
    editAll: function() {
        this.$.editing = !this.$.editing;
        for (var i=0; i<this.GradeSetupModelService.data.length; i++) {
            this.$.arrayCud.editItem[i] = !this.$.arrayCud.editItem[i];
        }
    },
    addGrade: function() {
        this.$.adding=true; 
        this.$.arrayCud.add();
        console.log(this.$.items);
    },
    applyToAll: function(value)
    {
        if (value == true) {
            this.$http.defaults.headers.common.applyToAll = 1;
            this.applyToAllModal();
        }
        else
            this.$http.defaults.headers.common.applyToAll = null;
    },
    applyToAllModal: function()
    {
        var parent = this;
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/gradeSetup/partials/applyModal.html?v=" + versionNo,
            controller: "ApplyModalController"
        }).result.then(
            function() {}, //Success
            function() //Dismiss
            {
                parent.applyToAll(false);
                parent.$.applyAll = false;  
            }
        );
    },
    setAllModal: function()
    {
        var parent = this;
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/gradeSetup/partials/setAllModal.html?v=" + versionNo,
            controller: "SetAllModalController"
        }).result.then(
            function() { parent.$.editing=true; }, //Success
            function() {} //Dismiss
        );

    },
    activeChange: function(index, field)
    {
        this.$.items[index][field] = Number(this.$.items[index][field]);
    },
    successSave: function(scope, instance)
    {
        var parent = this;
        this.$.arrayCud.editItem = [];  
        this.$.editing = this.$.adding = false;
        this.GradeSetupModelService.resolveData().then(function() { // refesh data
            parent.$.items = parent.GradeSetupModelService.data; 
        });
    }
});
